import { Divider, Stack } from '@mui/material';
import { DATE_TIME_FORMAT } from 'constants/date';
import { SUBSCRIPTION_PURCHASED_ITEM } from 'models/credits';
import { theme } from 'theme';
import { formatDate } from 'utils';
import {
  BookingCreditContainer,
  StyledDetailWrap,
  StyledTitleWrap,
  TextDetail,
} from './styles';

const TEXT_COLORS = {
  secondary: '#00000099',
};

interface SubPurchaseItemProps {
  data: SUBSCRIPTION_PURCHASED_ITEM;
}

interface DetailContentProps {
  label?: string;
  value?: string;
  amount?: number;
}

export function SubPurchaseItem({ data }: SubPurchaseItemProps) {
  const DetailContent = ({ label, value, amount }: DetailContentProps) => (
    <Stack
      spacing={0.25}
      textAlign={label === 'Total Amount' ? 'right' : 'left'}
    >
      <TextDetail color={TEXT_COLORS.secondary}>{label}</TextDetail>
      <TextDetail>
        {!(label === 'Total Amount') ? value : <span>${amount} </span>}
      </TextDetail>
    </Stack>
  );

  return (
    <BookingCreditContainer>
      <StyledTitleWrap>
        {data.number} - {data.package.name}
      </StyledTitleWrap>
      <Divider sx={{ borderColor: theme.palette.light.quaternary }} />
      <StyledDetailWrap>
        <Stack flexDirection="row" gap={3.5}>
          <DetailContent
            label="Purchase Date"
            value={formatDate(data.createdAt, {
              format: DATE_TIME_FORMAT.GENERAL,
            })}
          />
          <DetailContent
            label="Expiring in"
            value={formatDate(data.expiredAt, {
              format: DATE_TIME_FORMAT.NORMAL_DATE,
            })}
          />
        </Stack>
        <DetailContent label="Total Amount" amount={data.package.price} />
      </StyledDetailWrap>
    </BookingCreditContainer>
  );
}

export default SubPurchaseItem;
